const PbxxRecord = require('../../pbxx_record')

module.exports = class CampaignReportingAdRunTasks extends PbxxRecord {
  static get class_name() {
    return 'CampaignReportingAdRunTasks'
  }
}
